// extracted by mini-css-extract-plugin
module.exports = {"locationCard":"styles_locationCard__g3Eu_","location":"styles_location__qFle0","cta":"styles_cta__C26fM","phone":"styles_phone__UtYgr","website":"styles_website__wKPNS"};